import { render, staticRenderFns } from "./CourseLoadDuration.vue?vue&type=template&id=1ae6fee2&scoped=true"
import script from "./CourseLoadDuration.vue?vue&type=script&lang=js"
export * from "./CourseLoadDuration.vue?vue&type=script&lang=js"
import style0 from "./CourseLoadDuration.vue?vue&type=style&index=0&id=1ae6fee2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae6fee2",
  null
  
)

export default component.exports